'use client'

import { CodeSnippet } from '@graftcode/design-system'

import { WIZARD_COPY } from '../../const'
import type { OutputSectionProps } from '../../types'

import styles from './OutputSection.module.scss'

export function OutputSection({ configJson, ggCommand }: OutputSectionProps) {
  const { output: copy, sections } = WIZARD_COPY

  return (
    <section className={styles.section} aria-labelledby="graft-filter-wizard-output">
      <h3 id="graft-filter-wizard-output" className={styles.sectionTitle}>
        {sections.output}
      </h3>
      <CodeSnippet code={configJson} language="json" copyButtonText={copy.copyConfig} />
      <CodeSnippet code={ggCommand} language="bash" copyButtonText={copy.copyCommand} />
    </section>
  )
}
